import { REACT_APP__URL_DATAFAN_BASE } from "@smp/utils";
import { apiRequestDatafan } from "../_helpers";
export const ApiDatafanOAuth = {
    getApp: (req) => apiRequestDatafan({
        endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/o/authorize/`,
        method: "GET",
        query: req,
    }),
    authorize: (req) => apiRequestDatafan({
        endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/o/authorize/`,
        method: "POST",
        body: req,
    }),
};
//# sourceMappingURL=oauth.js.map